import { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';

type Props = {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  focused: boolean;
};

function SelectionButton({ label, isSelected, onClick, focused }: Props) {
  const OptionRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (OptionRef?.current && focused) {
      const target = OptionRef.current as HTMLElement;
      setTimeout(() => {
        target.scrollIntoView({
          block: 'nearest',
        });
      }, 10);
    }
  }, [OptionRef, focused]);
  return (
    <DropdownItem
      ref={OptionRef}
      isSelected={isSelected}
      focused={focused}
      onMouseDown={onClick}
    >
      {label}
    </DropdownItem>
  );
}

const DropdownItem = styled.button<{ isSelected: boolean; focused: boolean }>`
  width: 100%;
  padding: 13px 20px;
  color: ${({ isSelected }) => (isSelected ? '#FFF' : '#3A3B3E')};
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  background-color: ${({ isSelected }) =>
    isSelected ? '#7CA7FA' : 'transparent'};
  transition: all 200ms;

  &:hover {
    color: #3a3b3e;
    background-color: #e5e6e8;
  }

  ${({ focused, isSelected }) =>
    focused &&
    !isSelected &&
    css`
      color: #3a3b3e;
      background-color: #e5e6e8;
    `}
`;

export default SelectionButton;
